import api from '@/services/backendApi';

const projectUrl = '/project/';
const config = { headers: { 'Content-Type': 'application/json' } };

export default {
	getAllProjects() {
		return api.get(`${projectUrl}getAll`);
	},
	getProjectById(id) {
		return api.get(`${projectUrl}get/${id}`);
	},
	createProject(newProject) {
		return api.post(
			`${projectUrl}create`,
			newProject,
			config,
		);
	},
	updateProject(updatedProject) {
		return api.put(
			`${projectUrl}update/${updatedProject._id}`,
			updatedProject,
			config,
		);
	},
	updateEndpoint(projectId, endpoint) {
		return api.put(
			`${projectUrl}${projectId}/endpoint/${endpoint._id}`,
			endpoint,
			config,
		);
	},
	createEndpoint(projectId, endpoint) {
		return api.post(
			`${projectUrl}${projectId}/endpoint/create`,
			endpoint,
			config,
		);
	},
	deleteProject(projectId) {
		return api.delete(`${projectUrl}delete/${projectId}`);
	},
	deleteEndpoint(projectId, endpointId) {
		return api.delete(`${projectUrl}${projectId}/endpoint/${endpointId}`);
	},
};
